export const clean = (value) => String(value ?? "").trim();

export const getApiError = (error, fallback = "Something went wrong.") =>
  error?.response?.data?.message || error?.message || fallback;

export const unwrapProfile = (response) => response?.data?.profile ?? null;

export const formatDate = (value) => {
  if (!value) return "";

  const date = String(value).slice(0, 10);
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(date);

  if (!match) return date;

  const [, year, month, day] = match;

  return `${day}/${month}/${year}`;
};

export const formatPeriod = (start, end, current = false) => {
  const startYear = start ? String(start).slice(0, 4) : "";
  const endYear = current ? "Present" : end ? String(end).slice(0, 4) : "";

  return (
    [startYear, endYear].filter(Boolean).join(" - ") || "Date not specified"
  );
};
